<enhanced-help componentName="projects" [compact]="true"></enhanced-help>

<div>
    <ngx-loading [show]="working"></ngx-loading>
    <form [formGroup]="formGroup" novalidate>
        <div *ngIf="!working">
            <table class="table">
                <thead>
                    <tr>
                        <th class="sortable" style="width: 40%">
                            <span (click)="sort('name')">
                                Name
                                <ng-container *ngIf="sortList['name']">
                                    <span
                                        *ngIf="sortList['name'].ascending"
                                        class="fa fa-sort-up"
                                    >
                                    </span>
                                    <span
                                        *ngIf="!sortList['name'].ascending"
                                        class="fa fa-sort-down"
                                    >
                                    </span>
                                </ng-container>
                                <span
                                    *ngIf="!sortList['name']"
                                    class="fal fa-sort"
                                ></span>
                            </span>
                        </th>
                        <th class="sortable" style="width: 25%">
                            <span (click)="sort('startDate')">
                                Start Date
                                <ng-container *ngIf="sortList['startDate']">
                                    <span
                                        *ngIf="sortList['startDate'].ascending"
                                        class="fa fa-sort-up"
                                    >
                                    </span>
                                    <span
                                        *ngIf="!sortList['startDate'].ascending"
                                        class="fa fa-sort-down"
                                    >
                                    </span>
                                </ng-container>
                                <span
                                    *ngIf="!sortList['startDate']"
                                    class="fal fa-sort"
                                ></span>
                            </span>
                        </th>
                        <th class="sortable" style="width: 25%">
                            <span (click)="sort('endDate')">
                                End Date
                                <ng-container *ngIf="sortList['endDate']">
                                    <span
                                        *ngIf="sortList['endDate'].ascending"
                                        class="fa fa-sort-up"
                                    >
                                    </span>
                                    <span
                                        *ngIf="!sortList['endDate'].ascending"
                                        class="fa fa-sort-down"
                                    >
                                    </span>
                                </ng-container>
                                <span
                                    *ngIf="!sortList['endDate']"
                                    class="fal fa-sort"
                                ></span>
                            </span>
                        </th>
                        <th style="width: 10%">
                            <div class="checkbox pull-right" style="margin: 0">
                                <mat-slide-toggle
                                    [(ngModel)]="showArchived"
                                    [ngModelOptions]="{ standalone: true }"
                                >
                                    Show archived projects?
                                </mat-slide-toggle>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody formGroupName="editForm">
                    <ng-container *ngFor="let project of projects">
                        <tr *ngIf="showArchived || !project.archived">
                            <td
                                [class.has-error]="
                                    hasError('editForm.projectName')
                                "
                            >
                                <input
                                    *ngIf="project.isEditing"
                                    class="form-control"
                                    formControlName="projectName"
                                />
                                <validation-messages
                                    *ngIf="project.isEditing"
                                    [control]="editForm.controls.projectName"
                                ></validation-messages>
                                <span *ngIf="!project.isEditing">{{
                                    project.name
                                }}</span>
                            </td>
                            <td>
                                <div
                                    *ngIf="project.isEditing"
                                    class="input-group"
                                    [class.has-error]="
                                        hasError('editForm.startDate')
                                    "
                                >
                                    <input
                                        class="form-control"
                                        #editStartDate="bsDatepicker"
                                        bsDatepicker
                                        formControlName="startDate"
                                        [readonly]="working"
                                        [isDisabled]="working"
                                    />
                                    <span
                                        class="input-group-addon btn-default"
                                        (click)="editStartDate.toggle()"
                                        [attr.aria-expanded]="
                                            editStartDate.isOpen
                                        "
                                    >
                                        <i
                                            class="glyphicon glyphicon-calendar"
                                            style="cursor: pointer"
                                        ></i>
                                    </span>
                                </div>
                                <validation-messages
                                    *ngIf="project.isEditing"
                                    [control]="editForm.controls.startDate"
                                ></validation-messages>
                                <span *ngIf="!project.isEditing">{{
                                    project.startDate | formatDate
                                }}</span>
                            </td>
                            <td>
                                <div
                                    *ngIf="project.isEditing"
                                    class="input-group"
                                    [class.has-error]="
                                        hasError('editForm.endDate')
                                    "
                                >
                                    <input
                                        class="form-control"
                                        #editEndDate="bsDatepicker"
                                        bsDatepicker
                                        formControlName="endDate"
                                        [minDate]="
                                            formGroup.get('editForm.startDate')
                                                .value
                                        "
                                        [readonly]="working"
                                        [isDisabled]="working"
                                    />
                                    <span
                                        class="input-group-addon btn-default"
                                        (click)="editEndDate.toggle()"
                                        [attr.aria-expanded]="
                                            editEndDate.isOpen
                                        "
                                    >
                                        <i
                                            class="glyphicon glyphicon-calendar"
                                            style="cursor: pointer"
                                        ></i>
                                    </span>
                                </div>
                                <validation-messages
                                    *ngIf="project.isEditing"
                                    [control]="editForm.controls.endDate"
                                ></validation-messages>
                                <span *ngIf="!project.isEditing">{{
                                    project.endDate | formatDate
                                }}</span>
                            </td>
                            <td class="actions">
                                <div class="inline" *ngIf="project.isEditing">
                                    <button
                                        class="btn btn-sm btn-primary"
                                        type="button"
                                        (click)="onUpdateProject()"
                                        [disabled]="
                                            working ||
                                            editForm.invalid ||
                                            editForm.pristine
                                        "
                                    >
                                        Save
                                    </button>
                                    <button
                                        class="btn btn-sm"
                                        type="button"
                                        (click)="onCancelEdit(project)"
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div class="inline" *ngIf="!project.isEditing">
                                    <button
                                        class="btn btn-sm btn-tertiary"
                                        type="button"
                                        (click)="onShowEditMode(project)"
                                    >
                                        <span class="fal fa-pencil-alt"></span>
                                    </button>
                                </div>
                                <div class="inline">
                                    <button
                                        *ngIf="!project.archived"
                                        type="button"
                                        class="btn btn-tertiary"
                                        (click)="onArchiveProject(project)"
                                        [disabled]="working"
                                        tooltip="Archive"
                                        placement="left"
                                    >
                                        <span class="fal fa-eye-slash"></span>
                                    </button>

                                    <button
                                        *ngIf="project.archived"
                                        type="button"
                                        class="btn btn-tertiary"
                                        (click)="onUnarchiveProject(project)"
                                        [disabled]="working"
                                        tooltip="Unarchive"
                                        placement="left"
                                    >
                                        <span class="fal fa-eye"></span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
                <tfoot formGroupName="addForm">
                    <tr>
                        <td [class.has-error]="hasError('addForm.projectName')">
                            <input
                                class="form-control"
                                formControlName="projectName"
                            />
                            <validation-messages
                                [control]="addForm.controls.projectName"
                            ></validation-messages>
                        </td>
                        <td>
                            <div
                                class="input-group"
                                [class.has-error]="
                                    hasError('addForm.startDate')
                                "
                            >
                                <input
                                    class="form-control"
                                    #startDatePicker="bsDatepicker"
                                    bsDatepicker
                                    formControlName="startDate"
                                    [readonly]="working"
                                    [isDisabled]="working"
                                />
                                <span
                                    class="input-group-addon btn-default"
                                    (click)="startDatePicker.toggle()"
                                    [attr.aria-expanded]="
                                        startDatePicker.isOpen
                                    "
                                >
                                    <i
                                        class="glyphicon glyphicon-calendar"
                                        style="cursor: pointer"
                                    ></i>
                                </span>
                            </div>

                            <validation-messages
                                [control]="addForm.controls.startDate"
                            ></validation-messages>
                        </td>
                        <td>
                            <div
                                class="input-group"
                                [class.has-error]="hasError('addForm.endDate')"
                            >
                                <input
                                    class="form-control"
                                    #endDatePicker="bsDatepicker"
                                    bsDatepicker
                                    formControlName="endDate"
                                    [minDate]="
                                        formGroup.get('addForm.startDate').value
                                    "
                                    [readonly]="working"
                                    [isDisabled]="working"
                                />
                                <span
                                    class="input-group-addon btn-default"
                                    (click)="endDatePicker.toggle()"
                                    [attr.aria-expanded]="endDatePicker.isOpen"
                                >
                                    <i
                                        class="glyphicon glyphicon-calendar"
                                        style="cursor: pointer"
                                    ></i>
                                </span>
                            </div>
                            <validation-messages
                                [control]="addForm.controls.endDate"
                            ></validation-messages>
                        </td>
                        <td>
                            <button
                                type="button"
                                class="btn btn-sm btn-primary pull-right"
                                [disabled]="
                                    working ||
                                    addForm.invalid ||
                                    addForm.pristine
                                "
                                (click)="createProject()"
                            >
                                Add
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </form>
</div>
